@let node = nodeSg();
@let open = openSg();

@switch (node.kind) {
  @case ('null') {
    <span class="atn-json-tree__token atn-json-tree__token--null">null</span>
  }
  @case ('boolean') {
    <span class="atn-json-tree__token atn-json-tree__token--boolean">{{
      node.value
    }}</span>
  }
  @case ('number') {
    <span class="atn-json-tree__token atn-json-tree__token--number">{{
      node.value
    }}</span>
  }
  @case ('string') {
    <span class="atn-json-tree__token atn-json-tree__token--string"
      >"{{ node.value }}"</span
    >
  }
  @case ('array') {
    @if (node.items.length === 0) {
      <span class="atn-json-tree__token atn-json-tree__token--bracket"
        >[ ]</span
      >
    } @else {
      <details
        class="atn-json-tree__details"
        [attr.open]="open ? '' : null"
      >
        <summary class="atn-json-tree__summary">
          <span class="atn-json-tree__token atn-json-tree__token--bracket"
            >[</span
          >
          <span class="atn-json-tree__count"
            >{{ node.items.length }} item{{
              node.items.length === 1 ? '' : 's'
            }}</span
          >
          <span class="atn-json-tree__token atn-json-tree__token--bracket"
            >]</span
          >
          <button
            type="button"
            class="atn-json-tree__copy"
            [class.atn-json-tree__copy--copied]="justCopiedSg()"
            (click)="copyToClipboard($event)"
            [attr.title]="justCopiedSg() ? 'Copied!' : 'Copy JSON'"
            [attr.aria-label]="justCopiedSg() ? 'Copied' : 'Copy JSON'"
          >
            {{ justCopiedSg() ? '✓' : '⧉' }}
          </button>
        </summary>
        <ul class="atn-json-tree__list">
          @for (item of node.items; track $index) {
            <li class="atn-json-tree__entry">
              <span class="atn-json-tree__index">{{ $index }}:</span>
              <atn-json-tree
                [data]="item"
                [open]="false"
              />
            </li>
          }
        </ul>
      </details>
    }
  }
  @case ('object') {
    @if (node.entries.length === 0) {
      <span class="atn-json-tree__token atn-json-tree__token--bracket"
        >&#123; &#125;</span
      >
    } @else {
      <details
        class="atn-json-tree__details"
        [attr.open]="open ? '' : null"
      >
        <summary class="atn-json-tree__summary">
          <span class="atn-json-tree__token atn-json-tree__token--bracket"
            >&#123;</span
          >
          <span class="atn-json-tree__count"
            >{{ node.entries.length }} key{{
              node.entries.length === 1 ? '' : 's'
            }}</span
          >
          <span class="atn-json-tree__token atn-json-tree__token--bracket"
            >&#125;</span
          >
          <button
            type="button"
            class="atn-json-tree__copy"
            [class.atn-json-tree__copy--copied]="justCopiedSg()"
            (click)="copyToClipboard($event)"
            [attr.title]="justCopiedSg() ? 'Copied!' : 'Copy JSON'"
            [attr.aria-label]="justCopiedSg() ? 'Copied' : 'Copy JSON'"
          >
            {{ justCopiedSg() ? '✓' : '⧉' }}
          </button>
        </summary>
        <ul class="atn-json-tree__list">
          @for (entry of node.entries; track entry.key) {
            <li class="atn-json-tree__entry">
              <span class="atn-json-tree__key">{{ entry.key }}:</span>
              <atn-json-tree
                [data]="entry.value"
                [open]="false"
              />
            </li>
          }
        </ul>
      </details>
    }
  }
  @case ('other') {
    <span class="atn-json-tree__token">{{ node.text }}</span>
  }
}
